export const codeSelectorTranslations = {
  back: 7518,
  reports_company: 5330,
  select_case_type: 7431,
  change_case_type: 3717,
  change_case_type_info_message: 3878,
  dashboards: 6779,
  codetable_administration: 8268,
  no_access_to_codetable_administration: 8320,
  search: 7345,
  no_results: 8617,
  remove_bookmark: 8975,
  bookmark_case_type: 9034,
  toggle_between_case_types_and_bookmarks: 9035,
  bookmarked_case_types: 9036,
  no_bookmarked_case_types: 9037,
  all_active_case_types: 9038,
  no_active_case_types: 9039,
  draft_case_info_panel_title: 9962,
  draft_case_info_panel_continue: 9965,
  draft_case_info_panel_expires: 9969,
  draft_case_info_panel_view_all: 9966
};

export type CodeSelectorTranslation = {
  readonly [T in keyof typeof codeSelectorTranslations]: string
};

export const viewModeCacheKeyCaseTypes: string = 'caseTypesViewMode';
